var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1038_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99835 14.8364C5.29601 15.2894 4.45909 15.4869 3.62829 15.3956C2.7975 15.3041 2.0235 14.9295 1.43646 14.3345L0.923243 13.8327C0.698245 13.6025 0.572266 13.2935 0.572266 12.9717C0.572266 12.6499 0.698245 12.3407 0.923243 12.1107L3.10155 9.95512C3.32976 9.73085 3.63693 9.60518 3.95691 9.60518C4.27687 9.60518 4.58405 9.73085 4.81225 9.95512C5.04239 10.1801 5.35147 10.3061 5.67332 10.3061C5.99517 10.3061 6.30423 10.1801 6.53437 9.95512L9.95579 6.5337C10.0699 6.42122 10.1606 6.28718 10.2224 6.13936C10.2843 5.99154 10.3162 5.83289 10.3162 5.67265C10.3162 5.5124 10.2843 5.35376 10.2224 5.20593C10.1606 5.05812 10.0699 4.92407 9.95579 4.81159C9.73151 4.58339 9.60584 4.27621 9.60584 3.95624C9.60584 3.63627 9.73151 3.3291 9.95579 3.10088L12.1227 0.933985C12.3528 0.708986 12.6619 0.583008 12.9837 0.583008C13.3056 0.583008 13.6147 0.708986 13.8448 0.933985L14.3467 1.4472C14.9415 2.03424 15.3162 2.80824 15.4076 3.63903C15.499 4.46983 15.3015 5.30676 14.8484 6.00909C12.4876 9.48837 9.48371 12.4845 5.99835 14.8364Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1038_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.8c3253e0a61257762bacf2b52ae5fedf.svg";
export { ForwardRef as ReactComponent };